/** Slug de la política de privacidad en cada idioma (rutas en App.tsx y selector de idioma) */
export const RUTAS_PRIVACIDAD: Record<string, string> = {
  es: "politica-de-privacidad",
  en: "privacy-policy",
  pt: "politica-de-privacidade",
  fr: "politique-de-confidentialite",
};

/** Slug de las condiciones de contratación (campamentos y cumpleaños) en cada idioma */
export const RUTAS_CONDICIONES: Record<string, string> = {
  es: "condiciones-de-contratacion",
  en: "terms-and-conditions",
  pt: "condicoes-de-contratacao",
  fr: "conditions-generales",
};

const ruta = (slugs: Record<string, string>, idioma: string) =>
  slugs[idioma] ? `/${idioma}/${slugs[idioma]}` : `/es/${slugs.es}`;

/** Ruta completa de la política en el idioma dado (castellano si no es uno de los cuatro) */
export const rutaPrivacidad = (idioma: string) => ruta(RUTAS_PRIVACIDAD, idioma);

/** Ruta completa de las condiciones de contratación en el idioma dado */
export const rutaCondiciones = (idioma: string) => ruta(RUTAS_CONDICIONES, idioma);
